import React, { Component } from 'react';
import NavBarInverted from '../../components/nav/NavBarInverted.component.jsx';
import FooterLarge from '../../components/footer/FooterLarge.jsx';
import FooterHover from '../../components/footer/FooterHover.jsx';
import CareersCard from '../../components/careers/CareersCard';
import { api_url, headers } from '../../common/config';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component={'div'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `scrollable-prevent-tab-${index}`,
        'aria-controls': `scrollable-prevent-tabpanel-${index}`,
    };
}

class Careers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: 0,
            jobs: [],
            jobTypes: [],
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        if (i18next.language === 'ar') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'ar');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
            document.getElementById('root').style.textAlign = 'right';
            document.getElementById('root').dir = 'rtl';
        } else if (i18next.language === 'en') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
            document.getElementById('root').style.textAlign = 'left';
            document.getElementById('root').dir = 'ltr';
        }

        fetch(`${api_url}/autism/items/jobs?filter[status]=published`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    jobs: res.data,
                });
            });
        fetch(`${api_url}/autism/items/job_types?filter[status]=published`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    jobTypes: res.data,
                });
            });
    }

    handleChange = (e, v) => {
        this.setState({
            value: v,
        });
        this.jobsTypeFilter(v + 1);
    };
    jobsTypeFilter = (filterId) => {
        let filterIdVar = filterId;
        if (filterIdVar == 1) {
            filterIdVar = '';
        }
        fetch(
            `${api_url}/autism/items/jobs?filter[type][like]=${filterIdVar}&filter[status]=published`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    jobs: res.data,
                });
            });
    };

    render() {
        const { value } = this.state;
        const { t } = this.props;
        return (
            <>
                <div className='careers'>
                    <div className='careers-container'>
                        <NavBarInverted big careers />
                        <div className='careers-page'>
                            <h1
                                className={`title ${
                                    i18next.language === 'en' ? 'text-left' : ''
                                }`}
                            >
                                {t('careers.title')}
                            </h1>

                            <AppBar position='static'>
                                {i18next.language === 'ar' ? (
                                    <Tabs
                                        value={value}
                                        onChange={this.handleChange}
                                        variant='scrollable'
                                        scrollButtons='off'
                                        aria-label='scrollable prevent tabs example'
                                    >
                                        {this.state.jobTypes.map((jobType) => (
                                            <Tab
                                                label={jobType.ar_name}
                                                {...a11yProps(jobType.id - 1)}
                                            />
                                        ))}
                                    </Tabs>
                                ) : (
                                    <Tabs
                                        value={value}
                                        onChange={this.handleChange}
                                        variant='scrollable'
                                        scrollButtons='off'
                                        aria-label='scrollable prevent tabs example'
                                    >
                                        {this.state.jobTypes.map((jobType) => (
                                            <Tab
                                                label={jobType.en_name}
                                                {...a11yProps(jobType.id - 1)}
                                            />
                                        ))}
                                    </Tabs>
                                )}
                                <div class='fadedScroller_tabs'></div>
                            </AppBar>
                            {this.state.jobTypes.map((jobType) => (
                                <TabPanel value={value} index={jobType.id - 1}>
                                    {/* <CareersList jobs={this.state.jobs} /> */}
                                    {i18next.language === 'ar' ? (
                                        <div className='career-list'>
                                            {this.state.jobs.map((job) => (
                                                <CareersCard
                                                    key={job.id}
                                                    description={
                                                        job.ar_description
                                                    }
                                                    name={job.ar_name}
                                                    form_url={`/register/job/${job.id}`}
                                                />
                                            ))}
                                        </div>
                                    ) : (
                                        <div className='career-list'>
                                            {this.state.jobs.map((job) => (
                                                <CareersCard
                                                    key={job.id}
                                                    description={
                                                        job.en_description
                                                    }
                                                    name={job.en_name}
                                                    form_url={`/register/job/${job.id}`}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </TabPanel>
                            ))}
                        </div>
                    </div>
                    <FooterLarge minimal />
                </div>
                <FooterHover />
            </>
        );
    }
}

export default withTranslation()(Careers);
